import Vue from 'vue'
import VueRouter from 'vue-router'
import Swal from "sweetalert2";

Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: 'Login',
    component: () =>
        import('../views/login/pages/login/login_page.vue')
},
{
    path: '/main',
    name: 'main',
    component: () =>
        import('../views/main.vue'),
    children: [
        {
            path: '/home',
            name: 'home',
            component: () =>
                import('../views/home/pages/home_page.vue'),
            props: true
        },
        {
            path: '/product',
            name: 'product',
            component: () =>
                import('../views/products/pages/list_products/products_page.vue')
        },
        {
            path: '/companies',
            name: 'companies',
            component: () =>
                import('../views/companies/pages/list_companies/companies_page.vue')
        },
        {
            path: '/cargues',
            name: 'cargues',
            component: () =>
                import('../views/cargues/pages/upload_file/upload_file_page.vue')
        },
        {
            path: '/marketplace',
            name: 'marketplace',
            component: () =>
                import('../views/categories_marketplace/pages/list_categories_marketplace/category_marketplace_page.vue')
        },
        {
            path: '/board',
            name: 'board',
            component: () =>
                import('../views/categories_board/pages/list_categories/category_page.vue')
        },
        {
            path: '/users_admin',
            name: 'users_admin',
            component: () =>
                import('../views/users_admin/pages/list_users_admin/users_admin_page.vue')
        },
        {
            path: '/buy_recognition',
            name: 'buy_recognition',
            component: () =>
                import('../views/recognition/pages/buy_recognition/buy_recognition_page.vue')
        },
        {
            path: '/suppliers',
            name: 'suppliers',
            component: () =>
                import('../views/suppliers/pages/list_suppliers/suppliers_page.vue')
        },
        {
            path: '/purchase_reconciliation',
            name: 'purchase_reconciliation',
            component: () =>
                import('../views/purchase_reconciliation/pages/list_purchase_reconciliation/purchase_reconciliation_page.vue')
        },
        {
            path: '/shape_assignment',
            name: 'shape_assignment',
            component: () =>
                import('../views/star_assignment/pages/star_assignment/star_assignment_page.vue')
        },
        {
            path: '/reports',
            name: 'reports',
            component: () =>
                import('../views/reports/pages/list_reports/reports_page.vue')
        },
        {
            path: '/bonus',
            name: 'bonus',
            component: () =>
                import('../views/bonus/pages/list_bonus/bonus_page.vue')
        },
        {
            path: '/ads',
            name: 'ads',
            component: () =>
                import('../views/novelties/pages/list_novelties/novelties_page.vue')
        },
        {
            path: '/zen_star',
            name: 'zen_star',
            component: () =>
                import('../views/star_assignment/star_assignment_zen/star_assignment_zen_page.vue')
        },
        {
            path: '/mindset',
            name: 'mindset',
            component: () =>
                import('../views/mindset/pages/list_mindsets/mindsets_page.vue')
        },
        {
            path: '/tips-categories',
            name: 'tips-categories',
            component: () =>
                import('../views/tips-categories/pages/list_tips/list_tips_page.vue')
        },
        {
            path: '/happiness-tips',
            name: 'happiness-tips',
            component: () =>
                import('../views/happiness-tips/pages/list_happiness-tips/list_happiness_tips_page.vue')
        },
        {
            path: '/happiness-tips/categories',
            name: 'happiness-tips-categories',
            component: () =>
                import('../views/happiness-tips/pages/list_happiness-tips-categories/list_happiness_tips_categories_page.vue')
        },
        {
            path: '/surveys',
            name: 'surveys',
            component: () =>
                import('../views/surveys/pages/list_surveys/surveys_page.vue')
        },
        {
            path: '/surveys/create',
            name: 'surveys-create',
            component: () =>
                import('../views/surveys/pages/create_survey/create_survey_page.vue')
        },
        {
            path: '/surveys/results',
            name: 'surveys-results',
            component: () =>
                import('../views/surveys/pages/survey_results/survey_results_page.vue')
        },
    ]
},
{
    path: '',
    redirect: '/login',
    pathMatch: 'full'
}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const allowedScreens = JSON.parse(sessionStorage.getItem('allowedScreens')) || [];
    const imagePage = sessionStorage.getItem('bucket');
    const routeExists = routes.some(route => {
        return (
            route.path === to.path ||
            (route.children && route.children.some(child => child.path === to.path))
        );
    });

    const cleanedAllowedScreens = allowedScreens
        .filter(screen => screen !== null && screen !== undefined)
        .map(screen => screen.trim());

    const isAllowedRoute = cleanedAllowedScreens.includes(to.name ? to.name.trim() : '');

    const isAuthenticated = !!sessionStorage.getItem('token');
    
    const isAuthenticated2 = !!sessionStorage.getItem("roleId")

    // Redirigir si el usuario está autenticado y quiere acceder a /login
    if (isAuthenticated && to.name === 'Login') {
        return next({ name: 'home' }); // Cambia 'home' al nombre que tengas configurado
    }
    else if(!isAuthenticated2 && to.name === 'Login') {
        return next(); 
    }

    const tempAllowedRoutes = ['surveys', 'surveys-create', 'surveys-results'];

    if (!routeExists || (to.name !== 'Login' && !isAllowedRoute && !tempAllowedRoutes.includes(to.name))) {
        Swal.fire({
            title: 'Página no encontrada',
            confirmButtonColor: '#6E17A5',
            imageUrl: imagePage+"label/result-empty.svg",
            imageWidth: 400,
            imageHeight: 200,
        }).then(() => {
            router.push({ path: '/home' })
        });
    } else {
        next();
    }
    
});

export default router